// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c83113a","667":"de731e95"}[chunkId] + ".chunk.js";
};